import { Component, EventEmitter, Inject, Input, OnChanges, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CotizadorService } from 'src/app/services/cotizador.service';
import { DataService } from 'src/app/services/data.service';
import { WINDOW } from 'src/app/utils/window';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-related-cars',
  templateUrl: `./related-cars.component${environment.templateSuffix}.html`,
  styleUrls: ['./related-cars.component.scss']
})
export class RelatedCarsComponent implements OnChanges {
  @Output() public destroyQuoter = new EventEmitter();
  @Input() car!: any
  @Input() isAfin: boolean = false;
  @Input() productType: string = "";
  relatedCars: any[] = [];
  carId: any;
  brand: any;
  subBrand: any;
  priceWithIva: any;
  type: any;
  powerTrain: any;
  transmission: any;
  ranking: any;

  screenSize = this.window.innerWidth;

  options = {
    cellsToShow: 1,
    dots: true,
    arrows: true
  }

  subscriptionSize!: Subscription

  constructor(
    private cotizadorService: CotizadorService, 
    private dataService: DataService,
    @Inject(WINDOW) private window: Window) {
    this.evaluateShow(this.screenSize);
  }

  ngOnChanges(changes: any): void {
    this.relatedCars = [];
    this.getRelatedCars()

    this.subscriptionSize = this.dataService.getScreenSize().subscribe(res => {
      this.screenSize = res;
      this.evaluateShow(this.screenSize);
    });
  }

  getRelatedCars() {
    this.cotizadorService.getRelatedCars(`carId=${this.car.id}&brand=${this.car.brand}&subBrand=${this.car.subBrand}&priceWithIva=${this.car.priceWithIva}&type=${this.car.type}&powerTrain=${this.car.powerTrain}&transmission=${this.car.transmission}&ranking=${this.car.rankeo}`).subscribe(
      (res) => {
        this.relatedCars = res;
      }
    )
  }

  evaluateShow(screen: number) {
    switch (true) {
      case screen < 768:
        this.options.cellsToShow = 1;
        break;
      case screen < 968:
        this.options.cellsToShow = 2;
        break;
      case screen < 1200:
        this.options.cellsToShow = 3;
        break;
      default:
        this.options.cellsToShow = 4;
        break;
    }
  }


  emitDestroyQuoter(){
    this.destroyQuoter.emit();
  }


}
